import _extends from '@babel/runtime/helpers/extends';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import EnterpriseIcon, { ErrorFilledIcon } from '@enterprise-ui/icons';
import classnames from 'classnames';
import React__default from 'react';

var _excluded = ["children", "className", "disabled", "error"];

// HINT TEXT
var InputInfo = function InputInfo(_ref) {
  var children = _ref.children,
    className = _ref.className,
    disabled = _ref.disabled,
    error = _ref.error,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var finalClasses = classnames('C-Input--type-info', {
    isDisabled: disabled,
    isErrored: error
  }, className);
  return /*#__PURE__*/React__default.createElement("p", _extends({
    className: finalClasses,
    role: "alert"
  }, otherProps), error && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("span", {
    className: "hc-sr-only",
    "data-testid": otherProps['data-testid'] ? "".concat(otherProps['data-testid'], "_sr_text") : null
  }, "Orange circle icon with exclamation point"), /*#__PURE__*/React__default.createElement(EnterpriseIcon, {
    className: "C-Input--type-info__Icon hc-mr-min",
    icon: ErrorFilledIcon,
    size: "inline"
  })), children);
};
InputInfo.displayName = 'Input.Info';

export { InputInfo as default };
